import _ from 'lodash';
import { createSelector } from 'reselect';
import {
    get,
    isEqual,
    includes
} from 'lodash';
import {
    SELF_LOAD,
    SELF_FAILURE,
    SELF_SUCCESS
} from './selfActions';
import {
    USER_UPDATE_SUCCESS
} from '../UserSettings/userSettingsActions';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case SELF_LOAD:
            newState = {
                ...state,
                loading: true,
                isUpdateSuccess: false
            };

            return isEqual(state, newState) ? state : newState;

        case SELF_SUCCESS:
            newState = {
                ...state,
                loading: false,
                isSuccessful: true,
                self: action.self
            };

            return isEqual(state, newState) ? state : newState;

        case SELF_FAILURE:
            newState = {
                ...state,
                error: action.error,
                isSuccessful: false,
                loading: false
            };

            return isEqual(state, newState) ? state : newState;

        case USER_UPDATE_SUCCESS:
            newState = {
                ...state,
                self: _.merge(state.self, action.user),
                isUpdateSuccess: true
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getSelfEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'self')
);

export const getSelf = createSelector(
    getSelfEntity,
    (entity) => get(entity, 'self')
);

export const getIsUpdateSuccess = createSelector(
    getSelfEntity,
    (entity) => get(entity, 'isUpdateSuccess')
);

export const getFirstName = createSelector(
    getSelf,
    (self) => get(self, 'firstName')
);

export const getLastName = createSelector(
    getSelf,
    (self) => get(self, 'lastName')
);

export const getFullName = createSelector(
    getFirstName,
    getLastName,
    (first = '', last = '') => `${first} ${last}`.trim()
);

export const getUserName = createSelector(
    getSelf,
    (self) => get(self, 'userName')
);

export const getCustomAccess = createSelector(
    getSelf,
    (self) => get(self, 'customAccess')
);

export const getAccountType = createSelector(
    getSelf,
    (self) => get(self, 'accountType')
);

export const getRole = createSelector(
    getSelf,
    (self) => get(self, 'role')
);

export const getIsLoggedInAs = createSelector(
    getSelf,
    (self) => get(self, 'isLoggedInAs')
);

export const getIsLoading = createSelector(
    getSelfEntity,
    (entity) => get(entity, 'loading')
);

export const getIsSuccessful = createSelector(
    getSelfEntity,
    (entity) => get(entity, 'isSuccessful')
);

export const getError = createSelector(
    getSelfEntity,
    (entity) => get(entity, 'error')
);

export const getErrorMessage = createSelector(
    getError,
    (error) => get(error, 'message')
);

export const getAccessRights = createSelector(
    getSelf,
    (self) => get(self, 'accessRights')
);

export const getMerchantsAccessRights = createSelector(
    getAccessRights,
    (accessRights) => get(accessRights, 'merchantIds')
);

export const getAccessRightsForMerchant = createSelector(
    getMerchantsAccessRights,
    (state, merchantId) => merchantId,
    (merchantAccessRights, merchantId) => get(merchantAccessRights, merchantId)
);

export const getDoesUserHaveWriteAccessForMerchant = createSelector(
    getAccessRightsForMerchant,
    (state, merchantId) => merchantId,
    (userMerchantAccessRights) => {
        const rolesWithWriteAccess = ['A', 'W'];

        return includes(rolesWithWriteAccess, userMerchantAccessRights);
    }
);

export const getIsEnabledForVTerm = createSelector(
    getSelf,
    (self) => get(self, 'isEnabledForVTerm')
);

export const getPayoutAccountAccessRights = createSelector(
    getSelf,
    (self) => !_.isEmpty(get(self, 'payoutAccessRights'))
);
